import React from 'react';

import { FOHBannerText, FOHColors, FOHSuccessIcon } from '../../ingredients';

import { FOHBannerProps, BannerView } from './FOHBanner';

export const FOHSuccessBanner = (props: FOHBannerProps) => (
  <BannerView
    style={{
      backgroundColor: FOHColors.GREEN,
      borderRadius: props.rounded ? 6 : 0
    }}
    testID="FOHSuccessBanner"
  >
    <FOHSuccessIcon />
    <FOHBannerText>{props.message}</FOHBannerText>
  </BannerView>
);
